import type { ApiEndpoints } from '../api-endpoints';

/**
 * API map of endpoints, used to define the API endpoints for the application.
 */
export const apiEndpointsConfig: ApiEndpoints = {
  /*
   * Endpoints for Game history
   */
  fetchGameHistory: '',
  fetchGameHistoryDetails: '',

  /*
   * Endpoints for Games
   */
  fetchGames: '',
  fetchGameDetails: '',

  /*
   * Endpoints for Home
   */

  /*
   * Endpoints for Mailing
   */
  fetchUserNotificationsPreferences:
    '/core-client/api/user/profile/preferences',
  updateUserNotificationsPreferences:
    '/core-client/api/user/profile/preferences',

  /*
   * Endpoints for Notifications
   */

  /*
   * Endpoints for Prizes
   */
  fetchPrizes: '',

  /*
   * Endpoints for Promo codes
   */
  fetchPromoCodes: '',
  addPromoCode: '',

  /*
   * Endpoints for Terms and conditions
   */

  /*
   * Endpoints for Tournaments
   */

  /*
   * Endpoints for User game profile
   */

  /*
   * Endpoints for User profile
   */

  /*
   * Endpoints for Wallet
   */
};
